import React from 'react';
import PropTypes from 'prop-types';
import ComContext from './ComContext';

function ComProvider(_ref) {
  var AddToCartComponent = _ref.AddToCartComponent,
      children = _ref.children,
      ProductParameterValueComponent = _ref.ProductParameterValueComponent;
  return /*#__PURE__*/React.createElement(ComContext.Provider, {
    value: {
      AddToCartComponent: AddToCartComponent,
      ProductParameterValueComponent: ProductParameterValueComponent
    }
  }, children);
}

ComProvider.propTypes = {
  AddToCartComponent: PropTypes.elementType.isRequired,
  children: PropTypes.node,
  ProductParameterValueComponent: PropTypes.elementType.isRequired
};
ComProvider.defaultProps = {
  children: null
};
export default ComProvider;